// import React, { useState } from 'react';
// import { Button, InputGroup, FormControl } from 'react-bootstrap';
// import { duplicatePost, updateContent } from '../api/wordpress';
// import { generateContent } from '../api/content';

interface Props {
    needleInputs: any[];
    updateNeedleValue: (index: number, value: string) => void;
    addNeedleInput: () => void;
    addStatusMessage: (message: string) => void;
    setIsLoading: (loading: boolean) => void;
    originalPostId: number;
    setStatusMessages: (messages: string[]) => void;
}

// eslint-disable-next-line no-empty-pattern
const SingleLandingPageGenerator: React.FC<Props> = ({
    // needleInputs,
    // updateNeedleValue,
    // addNeedleInput,
    // addStatusMessage,
    // setIsLoading,
    // originalPostId,
    // setStatusMessages
}) => {

    // const [duplicatedPostId, setDuplicatedPostId] = useState<number | undefined>(undefined);
    // const [industry, setIndustry] = useState('');
    // const [service, setService] = useState('');

    // const handleDuplicate = async () => {
    //     addStatusMessage("Duplicating post...");
    //     try {
    //         const newPostId = await duplicatePost(originalPostId);
    //         if (newPostId === undefined) {
    //             addStatusMessage("Failed to duplicate post. Aborting.");
    //             return; // Exit if duplication failed
    //         }
    //         setDuplicatedPostId(newPostId);
    //         addStatusMessage(`Duplicated post successfully! New Post ID: ${newPostId}`);

    //     } catch (error) {
    //         console.error(error);
    //         if (error instanceof Error) {
    //             addStatusMessage(error.message);
    //         } else {
    //             addStatusMessage('An unknown error occurred.');
    //         }
    //     }
    // };


    // const handleGenerateForNeedle = async (needleIndex: number) => {
    //     setIsLoading(true);
    //     const needle = needleInputs[needleIndex];

    //     if (!duplicatedPostId) {
    //         addStatusMessage("Please duplicate the post first.");
    //         return;
    //     }

    //     addStatusMessage(`Generating content based on ${needle}...`);
    //     try {
    //         const generatedContent = await generateContent(needle.needle, duplicatedPostId, industry, service, null);
    //         if (generatedContent) {
    //             addStatusMessage(`Generating content based on ${needle}... Success!`);
    //             addStatusMessage(`Updating post ID: ${duplicatedPostId}...`);
    //             try {
    //                 await updateContent(needle.needle, generatedContent.content, duplicatedPostId);
    //                 addStatusMessage(`Updating post ID: ${duplicatedPostId}... Success!`);
    //             } catch (error) {
    //                 console.error(error);
    //                 addStatusMessage(`Updating post ID: ${duplicatedPostId}... Failed!`);
    //             }
    //         } else {
    //             addStatusMessage(`Generating content based on ${needle}... Failed!`);
    //         }
    //         setIsLoading(false);
    //         setStatusMessages([]);
    //     } catch (error) {
    //         if (error instanceof Error) {
    //             addStatusMessage(error.message);
    //         } else {
    //             addStatusMessage('An unknown error occurred.');
    //         }
    //     }
    //     setIsLoading(false);
    //     setStatusMessages([]);
    // };

    return (
        <>
            {/* <Button variant="success" onClick={handleDuplicate} className="mb-3">
                Duplicate Original Post
            </Button>
            <InputGroup className="mb-3">
                <InputGroup.Text>Industry</InputGroup.Text>
                <FormControl placeholder="Enter industry" onChange={(e) => setIndustry(e.target.value)} />
            </InputGroup>

            <InputGroup className="mb-3">
                <InputGroup.Text>Service</InputGroup.Text>
                <FormControl placeholder="Enter service" onChange={(e) => setService(e.target.value)} />
            </InputGroup>
            {needleInputs.map((needle, index) => (
                <InputGroup key={index} className="mb-3">
                    <InputGroup.Text>Needle {index + 1}</InputGroup.Text>
                    <FormControl
                        placeholder={`Enter needle ${index + 1}`}
                        value={needle.needle}
                        onChange={(e) => updateNeedleValue(index, e.target.value)}
                    />
                    <Button variant="outline-primary" onClick={() => handleGenerateForNeedle(index)}>
                        Generate Content
                    </Button>
                </InputGroup>
            ))}
            <Button variant="secondary" onClick={addNeedleInput} className="mb-3">
                Add another needle
            </Button> */}
        </>
    );
};

export default SingleLandingPageGenerator;